import script from "./successfulPop.vue?vue&type=script&setup=true&name=successfulPop&lang=js"
export * from "./successfulPop.vue?vue&type=script&setup=true&name=successfulPop&lang=js"

import "./successfulPop.vue?vue&type=style&index=0&id=24ac9f09&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24ac9f09"]])

export default __exports__